import { Avatar, Select, Space } from 'antd';
import useApps from 'hooks/use-app';
import { useNavigate } from 'react-router-dom';

const AppSelector = () => {
  let navigate = useNavigate();
  const { appKey, appItems } = useApps();

  const onSelect = (value, event) => {
    navigate(`/${value}`);
  };

  return (
    <Select
      style={{ width: '300px' }}
      size="large"
      onSelect={onSelect}
      // Hidden apps (Admin) have no option here; show the placeholder.
      value={appItems.some(o => o.key === appKey) ? appKey : undefined}
      placeholder="Select an app"
      // Show every app without scrolling; the default 256px list height
      // clips the last entries (e.g. FutureFlex) behind a scrollbar.
      listHeight={appItems.length * 48}
      virtual={false}
    >
      {appItems.map(o => (
        <Select.Option key={o.key} value={o.key}>
          <Space>
            <Avatar style={{ backgroundColor: o.color }}>
              {o.key.charAt(0).toUpperCase()}
            </Avatar>
            {o.label}
          </Space>
        </Select.Option>
      ))}
    </Select>
  );
};

export default AppSelector;
